import type { FC } from 'react';

import {
  SkeletonBodyCopy,
  SkeletonHeadline,
  SkeletonProfileImage,
} from '@xing-com/skeleton';

import * as Styled from './simple-company-card.styled';

type SimpleCompanyCardSkeletonProps = {
  horizontal?: boolean;
};
export const SimpleCompanyCardSkeleton: FC<SimpleCompanyCardSkeletonProps> = ({
  horizontal,
}) => {
  const profileImageSize = horizontal ? 'medium' : 'large';
  const InfoContainerAlignment = horizontal ? 'left' : 'center';

  return (
    <Styled.SkeletonCard
      horizontal={horizontal}
      data-testid="entity-card-loading-skeleton"
    >
      <Styled.SkeletonProfileContainer horizontal={horizontal}>
        <div>
          <SkeletonProfileImage size={profileImageSize} />
        </div>
      </Styled.SkeletonProfileContainer>
      <Styled.SkeletonInfoContainer horizontal={horizontal}>
        <SkeletonHeadline
          alignment={InfoContainerAlignment}
          amountRows={1}
          size="medium"
        />
        <SkeletonBodyCopy alignment={InfoContainerAlignment} amountRows={2} />
      </Styled.SkeletonInfoContainer>
    </Styled.SkeletonCard>
  );
};
